import React from "react";

const MorningBig = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3606_2)">
      <rect
        x="4"
        y="4"
        width="24"
        height="24"
        rx="4"
        fill="#FFF4CC"
        fill-opacity="0.5"
        shape-rendering="crispEdges"
      />
    </g>
    <path
      d="M15.9949 19.5894C15.0597 19.5894 14.1628 19.218 13.5015 18.5567C12.8401 17.8954 12.4688 16.9985 12.4688 16.0633C12.4688 15.1281 12.8402 14.2312 13.5015 13.5698C14.1628 12.9085 15.0597 12.5371 15.9949 12.5371C16.9301 12.5371 17.827 12.9085 18.4884 13.5698C19.1497 14.2311 19.5211 15.1281 19.5211 16.0633C19.5211 16.9985 19.1497 17.8954 18.4884 18.5567C17.827 19.2181 16.9301 19.5894 15.9949 19.5894ZM15.9949 13.5445C15.3269 13.5445 14.6862 13.8098 14.2139 14.2822C13.7415 14.7545 13.4762 15.3952 13.4762 16.0632C13.4762 16.7312 13.7415 17.372 14.2139 17.8442C14.6862 18.3167 15.3269 18.5819 15.9949 18.5819C16.6629 18.5819 17.3037 18.3167 17.7759 17.8442C18.2484 17.372 18.5136 16.7312 18.5136 16.0632C18.5136 15.3952 18.2483 14.7545 17.7759 14.2822C17.3037 13.8098 16.6629 13.5445 15.9949 13.5445Z"
      fill="#E9B600"
    />
    <path
      d="M15.9881 23.0027C15.7098 23.0027 15.4844 22.7771 15.4844 22.4988V21.5896C15.4844 21.3115 15.7098 21.0859 15.9881 21.0859C16.2664 21.0859 16.4918 21.3115 16.4918 21.5896V22.4913C16.4939 22.6262 16.4417 22.7564 16.347 22.8525C16.2523 22.9486 16.123 23.0027 15.9881 23.0027H15.9881Z"
      fill="#E9B600"
    />
    <path
      d="M15.9881 11.015C15.7098 11.015 15.4844 10.7894 15.4844 10.5113V9.5037C15.4844 9.22558 15.7098 9 15.9881 9C16.2664 9 16.4918 9.22559 16.4918 9.5037V10.5113C16.4918 10.6448 16.4387 10.7731 16.3442 10.8674C16.2498 10.9619 16.1216 11.015 15.9881 11.015L15.9881 11.015Z"
      fill="#E9B600"
    />
    <path
      d="M22.4804 16.5523H21.5232C21.2451 16.5523 21.0195 16.3269 21.0195 16.0486C21.0195 15.7703 21.2451 15.5449 21.5232 15.5449H22.4804C22.7585 15.5449 22.9841 15.7703 22.9841 16.0486C22.9841 16.3269 22.7585 16.5523 22.4804 16.5523Z"
      fill="#E9B600"
    />
    <path
      d="M10.448 16.5523H9.49589C9.21759 16.5523 8.99219 16.3269 8.99219 16.0486C8.99219 15.7703 9.2176 15.5449 9.49589 15.5449H10.448C10.7261 15.5449 10.9517 15.7703 10.9517 16.0486C10.9517 16.3269 10.7261 16.5523 10.448 16.5523Z"
      fill="#E9B600"
    />
    <path
      d="M11.3259 21.1664C11.1228 21.1657 10.94 21.0429 10.8624 20.8552C10.7849 20.6676 10.8276 20.4517 10.9708 20.3076L11.666 19.6124H11.6658C11.8649 19.4163 12.185 19.4186 12.3812 19.6175C12.5773 19.8164 12.575 20.1366 12.3761 20.3327L11.6809 21.0179C11.5869 21.1124 11.4592 21.1658 11.3258 21.1663L11.3259 21.1664Z"
      fill="#E9B600"
    />
    <path
      d="M19.8453 12.6847C19.6422 12.6838 19.4595 12.5612 19.382 12.3736C19.3044 12.1857 19.3471 11.9698 19.4903 11.8259L20.1879 11.1282V11.128C20.3847 10.9313 20.704 10.9313 20.9007 11.128C21.0975 11.325 21.0975 11.6441 20.9007 11.841L20.2004 12.5312C20.1073 12.6276 19.9794 12.6828 19.8454 12.6847L19.8453 12.6847Z"
      fill="#E9B600"
    />
    <path
      d="M12.1243 12.6911C11.9909 12.6905 11.8632 12.6371 11.7692 12.5424L11.0891 11.8623V11.8625C10.8922 11.6656 10.8922 11.3465 11.0891 11.1495C11.2859 10.9528 11.6051 10.9528 11.8019 11.1495L12.482 11.8296C12.6273 11.9737 12.6709 12.1916 12.5925 12.3804C12.514 12.5695 12.329 12.6923 12.1243 12.691L12.1243 12.6911Z"
      fill="#E9B600"
    />
    <path
      d="M20.5482 21.1231C20.4149 21.1226 20.2872 21.0691 20.1932 20.9746L19.5382 20.3272C19.3414 20.1304 19.3414 19.8112 19.5382 19.6144C19.7352 19.4176 20.0542 19.4176 20.2512 19.6144L20.906 20.2692C21.046 20.4141 21.0863 20.6283 21.0084 20.814C20.9306 20.9997 20.7496 21.1213 20.5483 21.1231L20.5482 21.1231Z"
      fill="#E9B600"
    />
    <defs>
      <filter
        id="filter0_d_3606_2"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3606_2"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3606_2"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default MorningBig;
